import { RefObject, useState, useEffect } from 'react';

export function useVisibleItemCount(sliderRef: RefObject<HTMLElement | null>): number {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const { current: slider } = sliderRef;
        if (slider === null) {
            return;
        }
        const observer = new ResizeObserver(() => {
            const item = slider.querySelector('.Slider-item');
            if (item) {
                setCount(Math.floor(slider.clientWidth / item.clientWidth));
            } else {
                setCount(0);
            }
        });
        observer.observe(slider);
        return (): void => {
            observer.unobserve(slider);
        };
    }, []);

    return count;
}
